import { business } from '@icabbi/api-gateway-client';
import apiInstance from '@/helpers/apiInstance';

const defaultState = {
  accountsServiceClient: null,
  accountsLoading: false,
  accountsList: [],
  accountSelected: null,
};

const getInstance = ({ dispatch, rootGetters }) => {
  return apiInstance({
    dispatch,
    getters: rootGetters,
    Connector: business.CorporationServiceConnector
  });
};

const getters = {
  accountsLoading: (state) => state.accountsLoading,
  accountsList: (state) => state.accountsList,
  accountSelected: (state) => state.accountSelected,
};

/**
 * @param context
 * @param query
 * @returns {Promise<{data: *, headers: *}|undefined>}
 */
async function fetchAccountsList(context, query) {
  const instance = getInstance(context);

  return await instance.listCorporations(query);
}

/**
 * @param context
 * @param corporationId
 * @returns {Promise<{data: *, headers: *}|undefined>}
 */
async function fetchAccountById(context, corporationId) {
  const instance = getInstance(context);

  return await instance.findCorporationById({ id: corporationId });
}

/**
 * @param context
 * @param payload
 */
function updateAccount(context, payload) {
  const { id } = payload;
  const instance = getInstance(context);

  const updatedAccountsList = context.state.accountsList.map((account) => {
    if (account.id === id) {
      return {
        ...account,
        ...payload
      };
    }
    return account;
  });

  context.commit('setAccounts', updatedAccountsList);
  return instance.updateCorporation({
    id,
    ...payload
  })
}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions: {
    fetchAccountsList,
    fetchAccountById,
    updateAccount,
  },
  mutations: {
    setAccountsLoading: (state, loading) => state.accountsLoading = loading,
    setSelectedAccount: (state, selectedAccount) => {
      state.accountSelected = selectedAccount;
      localStorage.setItem('account_id', selectedAccount);
    },
    setAccounts: (state, accounts) => {
      state.accountsList = accounts;
    }
  }
}
